import { useSelector as _useSelector } from 'react-redux';
import { type AppState } from '~/store/app.store';

export const useSelector = <TResult>(selector: (state: AppState) => TResult) => _useSelector(selector);
